import { Component, DestroyRef, HostBinding, OnInit, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs';

import { ThemeService } from '@shared/services/theme/theme.service';

import { environment as env } from '../environments/environment';
import { AuthService } from './shared/services';
import { isDevEnv } from './shared/utils/is-dev-util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @HostBinding('class.tier-alpha') public isAlpha = env.tier === 'alpha';
  @HostBinding('class.tier-beta') public isBeta = env.tier === 'beta';
  @HostBinding('class.tier-staging') public isStaging = env.tier === 'staging';
  @HostBinding('class.tier-chaos') public isChaos = env.tier === 'chaos';
  @HostBinding('class.tier-develop') public isDevelop = isDevEnv(env.tier);

  public environment: { [key: string]: any } = env;
  public lang: string;

  constructor(
    private readonly logger: NGXLogger,
    private readonly translate: TranslateService,
    private readonly titleService: Title,
    private renderer2: Renderer2,
    private themeService: ThemeService,
    private authService: AuthService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    const title = `${env.theme.toUpperCase()} Nest${env.tier !== 'prod' ? ' - ' + env.tier.toUpperCase() : ''}`;
    console.log('env.tier ', env.tier);
    this.titleService.setTitle(title);

    this.lang = this.environment.defaultLanguage;
    moment.locale(this.lang);

    this.translate.addLangs(this.environment.supportedLanguages);
    this.translate.setDefaultLang(this.lang);
    this.translate.use(this.lang);

    this.logger.trace('Production value is ' + this.environment.production);
    this.logger.debug('Your tier is ' + this.environment.tier);
    this.logger.debug('Cookies of domain is ' + this.environment.cookies.domain);
    this.logger.info('Your appVersion is ' + this.environment.version);
    this.initialize();

    this.authService.triggerWebVersion$
      .pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap(route =>
          this.authService.getWebVersion().pipe(
            tap((shouldReload: boolean) => {
              if (shouldReload) {
                window.location.href = `${route}`;
              }
            })
          )
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  initialize() {
    this.themeService.setTheme(env.theme, this.renderer2);
  }
}
